import {
    AggregateFunctions,
    AggregateQueryInterval,
    ApiQuery,
    Filter,
    FilterOperators,
} from "~/modules/filters/types";
import {
    TokenTimeseriesColumns,
    TokenTimeseriesGroupBy,
} from "~/modules/token_timeseries/types";
import {
    SelectControlProps,
    VisualizationConfig,
    VisualizationMode,
    VisualizationModeTypes,
} from "~/modules/visualization/components/Timeseries/types";

// // // //

// ENHANCEMENT - make sort + pagination optional fields on ApiQuery
const BASE_QUERY: ApiQuery = {
    sort: {
        direction: "asc",
        field: "date",
    },
    pagination: {
        page: 1,
        perPage: 25,
    },
};

const visualizationConfig: VisualizationConfig = {
    area: true,
    enableZoom: false,
    showTotal: true,
    height: 350,
    legend: {
        enabled: true,
        itemWidth: 225,
        layout: "horizontal",
        align: "center",
        verticalAlign: "bottom",
    },
};

const DAILY_INTERVAL_CONTROLS: SelectControlProps<AggregateQueryInterval> = {
    enabled: false,
    forceUpdate: true,
    value: AggregateQueryInterval.day,
    allowedOptions: [AggregateQueryInterval.day],
};

// // // //

export function getSideBySideColumnChart(props: {
    key: string;
    label: string;
    description?: string;
    filters: Filter[];
    defaultGroupBy?: TokenTimeseriesGroupBy;
    enableGroupByControls?: boolean;
    measureSlug: string;
    loginRequired?: boolean;
    showTotal?: boolean;
}): VisualizationMode {
    const {
        key,
        label,
        description,
        filters,
        enableGroupByControls = true,
        defaultGroupBy = TokenTimeseriesGroupBy.assetClass,
        measureSlug,
        loginRequired,
        showTotal = true,
    } = props;
    return {
        key,
        type: VisualizationModeTypes.area, // QUESSTION - should this be column?
        loginRequired,
        content: {
            label,
            description,
        },
        queryControls: {
            groupBy: {
                enabled: enableGroupByControls,
                forceUpdate: true,
                value: defaultGroupBy,
                allowedOptions: [
                    TokenTimeseriesGroupBy.asset,
                    TokenTimeseriesGroupBy.assetClass,
                    TokenTimeseriesGroupBy.network,
                    TokenTimeseriesGroupBy.token,
                    TokenTimeseriesGroupBy.peggedAsset,
                    TokenTimeseriesGroupBy.protocol,
                    TokenTimeseriesGroupBy.issuer,
                    TokenTimeseriesGroupBy.jurisdictionCountry,
                ],
            },
            interval: DAILY_INTERVAL_CONTROLS,
        },
        visualizationConfig: {
            ...visualizationConfig,
            showTotal,
            columnPlotOptions: {
                stacking: null,
                groupPadding: 0.2,
            },
        },
        endpoint: null,
        query: {
            ...BASE_QUERY,
            aggregate: {
                aggregateFunction: AggregateFunctions.Sum,
                groupBy: defaultGroupBy,
                interval: AggregateQueryInterval.day,
            },
            filter: {
                operator: FilterOperators.And,
                filters: [
                    {
                        field: TokenTimeseriesColumns.measureSlug,
                        operator: FilterOperators.Equals,
                        value: measureSlug,
                    },
                    ...filters,
                ],
            },
        },
        visualizationControls: {
            stacked: {
                enabled: false,
                forceUpdate: true,
                active: false,
            },
            navigator: {
                active: false,
                enabled: false,
                // xAxis: {
                //     min: Number(TWO_YEARS_AGO),
                //     max: Number(TODAYS_DATE),
                // },
            },
        },
        apiTools: {
            enabled: false,
            baseUrl: "/v4/assets/aggregates/timeseries",
        },
        dataExportControls: {
            enabled: false,
            ignoreFeatureFlag: false,
        },
    };
}
